export const ASSET_STATUS_FILTER_DATA = [
    { value: "1;0;2;4;5", text: "All", key: "all" },
    { value: "1", text: "Installed", key: "installed" },
    { value: "0", text: "Not Installed", key: "notInstalled" },
    { value: "2", text: "Pending", key: "pending" },
    { value: "4", text: "Sold", key: "sold" },
    { value: "5", text: "Scrapped", key: "scrapped" },
];

export const STATUS_MAP = {
    "0": { label: "Not Installed", color: "red" },
    "1": { label: "Installed", color: "green" },
    "2": { label: "Pending", color: "orange" },
    "4": { label: "Sold", color: "purple" },
    "5": { label: "Scrapped", color: "blue" },
};